import React, {useState} from 'react';
import './MainComponent.css'
import { MAIN_SITE } from '../../utils/constants'

import Components from '../index';

const MainComponent = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const id = queryParams.get('id');
    const survey_type = queryParams.get("type");
    if(!survey_type || !id || isNaN(id))
    {
        window.location.replace(MAIN_SITE)
    }

    const initialSurvey = survey_type === "initial";
    // TODO:: Type of Survey Determination Logic
    // TODO:: Data framing for post request
    const [showForm, toggleForm] = useState(!initialSurvey)

    const startForm = () => {
        toggleForm(true)
    }
    
    const {HeaderComponent, FormComponent, InitialFormLandingComponent, FooterComponent} = Components
    return(
        <div className='full-height dis-flex flex-column'>
            <HeaderComponent initialSurvey={initialSurvey}></HeaderComponent>
            {showForm && <FormComponent initialSurvey={initialSurvey} id={id}></FormComponent>}
            {!showForm && <InitialFormLandingComponent startForm={startForm}></InitialFormLandingComponent>}
            <FooterComponent></FooterComponent>
        </div>
    )

}

export default MainComponent;